import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import TableContainer from "@mui/material/TableContainer";
import MDBox from "components/MDBox";
import { updateSetting, settingListApi } from "Apis/settings";
import { LoginFormContext } from "context/LoginFormContext";
import MDSwitch from "components/MdSwitch";
import SubmitButton from "components/SubmitButton";
import { userProfile } from "Apis/signIn";
import MDSelectBox from "components/MDSelectBox";
import { ForceUpdateData } from "helpers/constant";

const Settings = () => {
  const { setNotification } = useContext(LoginFormContext);
  const [businessDuration, setBusinessDuration] = useState();
  const [matrimonialDuration, setMatrimonialDuration] = useState();
  const [memberMobileNoDuration, setMemberMobileNoDuration] = useState();
  const [settings, setSettings] = useState([
    {
      id: 1,
      name: "Business Record Limit Duration (બિઝનેસ રેકોર્ડ સમયમર્યાદા કેટલા મહિના માટે રાખવી છે)",
      unit: "Months",
    },
    {
      id: 2,
      name: "Business Month Record Limit (બિઝનેસ રેકોર્ડ સમયમર્યાદા મુજબ મહિના માં કેટલા બિઝનેસ નાખી શકે છે)",
      unit: "Records",
    },
    {
      id: 3,
      name: "Matrimonial Record Limit Duration (મેટ્રિમોનિયલ રેકોર્ડ સમયમર્યાદા કેટલા મહિના માટે રાખવી છે)",
      unit: "Months",
    },
    {
      id: 4,
      name: "Matrimonial Month Record Limit (મેટ્રિમોનિયલ રેકોર્ડ સમયમર્યાદા મુજબ મહિના માં કેટલા મેટ્રિમોનિયલ નાખી શકે છે)",
      unit: "Records",
    },
    {
      id: 5,
      name: "Member Expire Duration (મુખ્ય મેમ્બરની મેમ્બરશિપ સમાપ્ત થવાની સમયમર્યાદા)",
      unit: "Months",
    },
    {
      id: 6,
      name: "Member See Mobile Number Duration (મુખ્ય મેમ્બર મોબાઈલ નંબર જોવા માટેની સમયમર્યાદા કેટલા મહિના માટે રાખવી છે)",
      unit: "Months",
    },
    {
      id: 7,
      name: "Member See Mobile Number In Month Limit (મુખ્ય મેમ્બર મોબાઈલ નંબર જોવાની સમયમર્યાદા મુજબ મહિના માં કેટલા મોબાઈલ નંબર જોઈ શકે છે)",
      unit: "Records",
    },
    {
      id: 8,
      name: "Daily OTP Request Limit Per Device For Members. (સભ્યો માટે એક જ મોબાઇલ પર દિવસમાં OTP મેળવવાની મર્યાદા)",
      unit: "Records",
    },
    {
      id: 9,
      name: "Android Version (એન્ડ્રોઇડ વર્ઝન)",
      unit: "Version",
    },
    {
      id: 13,
      name: "Android App URL",
      unit: "",
    },
    {
      id: 10,
      name: "IOS Version (આઇઓએસ સંસ્કરણ)",
      unit: "Version",
    },
    {
      id: 14,
      name: "IOS App URL",
      unit: "",
    },
    {
      id: 11,
      name: "Force Update (ફોર્સ અપડેટ)",
      unit: "Update",
    },
    {
      id: 12,
      name: "Debug Mode",
      unit: "Mode",
    },
  ]);

  const [role, setRole] = useState("");
  const [forceUpdate, setForceUpdate] = useState({
    label: "False",
    value: 0,
  });
  const [paymentMode, setPaymentMode] = useState({
    label: "False",
    value: 0,
  });

  const getProfile = async () => {
    let response = await userProfile();
    if (response?.status === 200) {
      setRole(response?.data?.data?.role?.name);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  // filter settings
  const filteredSettings = useMemo(() => {
    if (role === "Super Admin") {
      return settings;
    } else {
      return settings.filter((s) => ![9, 10, 11, 12, 13, 14].includes(s.id));
    }
  }, [role, settings]);

  const handleToggle = (index) => {
    const updatedSettings = [...filteredSettings];
    updatedSettings[index].is_active = updatedSettings[index].is_active === 1 ? 0 : 1;
    setSettings(updatedSettings);
  };

  const handleValueChange = (index, newValue) => {
    setSettings((prevSettings) => {
      const updated = [...prevSettings];
      const item = { ...updated[index] };
      if (item.id <= 8) {
        item.value = newValue;
      } else if (item.id === 9 || item.id === 10 || item.id === 13 || item?.id === 14) {
        item.value2 = newValue;
      }
      updated[index] = item;
      return updated;
    });
  };

  const fetchSettingList = async () => {
    try {
      let response = await settingListApi();
      const apiData = response.data.data.rows;
      const updatedSettings = settings.map((setting) => {
        const matched = apiData.find((item) => item.id === setting.id);
        if (matched) {
          return {
            ...setting,
            value: matched.value,
            value2: matched.value2,
            is_active: matched.is_active,
          };
        }
        return setting;
      });
      setSettings(updatedSettings);
      // Update forceUpdate state
      const forceUpdateSetting = updatedSettings.find((s) => s.id === 11);
      if (forceUpdateSetting) {
        setForceUpdate(
          forceUpdateSetting.value === 1
            ? { label: "True", value: 1 }
            : { label: "False", value: 0 }
        );
      }

      // Update paymentMode state
      const paymentModeSetting = updatedSettings.find((s) => s.id === 12);
      if (paymentModeSetting) {
        setPaymentMode(
          paymentModeSetting.value === 1
            ? { label: "True", value: 1 }
            : { label: "False", value: 0 }
        );
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    fetchSettingList();
  }, []);

  useEffect(() => {
    const business_duration = filteredSettings.find((data) => data.id === 1)?.value;
    if (business_duration !== undefined) {
      setBusinessDuration(business_duration);
    }

    const matrimonial_duration = filteredSettings.find((data) => data.id === 3)?.value;
    if (matrimonial_duration !== undefined) {
      setMatrimonialDuration(matrimonial_duration);
    }

    const member_mobile_no_duration = filteredSettings.find((data) => data.id === 6)?.value;
    if (member_mobile_no_duration !== undefined) {
      setMemberMobileNoDuration(member_mobile_no_duration);
    }
  }, [filteredSettings]);

  const handleSubmit = async () => {
    try {
      const updatedSettings = [...filteredSettings];

      // Update Force Update value
      const forceUpdateIndex = updatedSettings.findIndex((s) => s.id === 11);
      if (forceUpdateIndex !== -1) {
        updatedSettings[forceUpdateIndex].value = forceUpdate ? forceUpdate.value : 0;
      }

      // Update Payment Mode value
      const paymentModeIndex = updatedSettings.findIndex((s) => s.id === 12);
      if (paymentModeIndex !== -1) {
        updatedSettings[paymentModeIndex].value = paymentMode ? paymentMode.value : 0;
      }

      const response = await updateSetting(updatedSettings);
      if (response.status === 200) {
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
        fetchSettingList();
      }
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  // function to handle dynamic label
  const getSettingName = (setting) => {
    if (setting.id === 2) {
      return businessDuration
        ? `Business ${businessDuration} Month Record Limit (બિઝનેસ રેકોર્ડ સમયમર્યાદા મુજબ ${businessDuration} મહિના માં કેટલા બિઝનેસ નાખી શકે છે)`
        : "Business 1 Month Record Limit (બિઝનેસ રેકોર્ડ સમયમર્યાદા મુજબ 1 મહિના માં કેટલા બિઝનેસ નાખી શકે છે)";
    }
    if (setting.id === 4) {
      return matrimonialDuration
        ? `Matrimonial ${matrimonialDuration} Month Record Limit (મેટ્રિમોનિયલ રેકોર્ડ સમયમર્યાદા મુજબ ${matrimonialDuration} મહિના માં કેટલા મેટ્રિમોનિયલ નાખી શકે છે)`
        : "Matrimonial 1 Month Record Limit (મેટ્રિમોનિયલ રેકોર્ડ સમયમર્યાદા મુજબ 1 મહિના માં કેટલા મેટ્રિમોનિયલ નાખી શકે છે)";
    }
    if (setting.id === 7) {
      return memberMobileNoDuration
        ? `Member See Mobile Number In ${memberMobileNoDuration} Month Limit (મુખ્ય મેમ્બર મોબાઈલ નંબર જોવાની સમયમર્યાદા મુજબ ${memberMobileNoDuration} મહિના માં કેટલા મોબાઈલ નંબર જોઈ શકે છે)`
        : "Member See Mobile Number In 1 Month Limit (મુખ્ય મેમ્બર મોબાઈલ નંબર જોવાની સમયમર્યાદા મુજબ 1 મહિના માં કેટલા મોબાઈલ નંબર જોઈ શકે છે)";
    }
    return setting.name;
  };

  const handleForceUpdateChange = (value) => {
    if (value) {
      setForceUpdate(value);
    } else {
      setForceUpdate({ label: "False", value: 0 });
    }
  };

  const handlePaymentModeChange = (value) => {
    if (value) {
      setPaymentMode(value);
    } else {
      setPaymentMode({ label: "False", value: 0 });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TableContainer>
        <Box sx={{ padding: "20px" }}>
          <MDBox fontSize="20px" fontWeight="600" mb={3}>
            Application Setting Page
          </MDBox>

          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{ pl: 3, fontSize: "16px", color: "#7B809A", fontWeight: 1000 }}
                >
                  Setting Name
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ pl: 3, fontSize: "16px", color: "#7B809A", fontWeight: 1000 }}
                >
                  Setting Value
                </TableCell>
                <TableCell
                  align="left"
                  sx={{ pl: 3, fontSize: "16px", color: "#7B809A", fontWeight: 1000 }}
                >
                  Setting Status
                </TableCell>
              </TableRow>

              {filteredSettings.map((setting, index) => {
                return (
                  <TableRow key={setting.id}>
                    <TableCell
                      align="left"
                      sx={{ pl: 3, fontSize: "14px", color: "#7B809A", fontWeight: 600 }}
                    >
                      {getSettingName(setting)}
                    </TableCell>

                    <TableCell align="left" sx={{ pl: 3 }}>
                      <Box display="flex" alignItems="center" gap={2}>
                        {setting?.id === 11 && setting?.name === "Force Update (ફોર્સ અપડેટ)" ? (
                          <MDSelectBox
                            name="Force Update"
                            defaultValue={forceUpdate}
                            options={ForceUpdateData}
                            handleChange={(value) => handleForceUpdateChange(value)}
                            label=""
                            width={{ xs: "54%", sm: "45%", md: "55%", lg: "40%" }}
                            multiple={false}
                          />
                        ) : setting?.id === 12 && setting?.name === "Debug Mode" ? (
                          <MDSelectBox
                            name="Debug Mode"
                            defaultValue={paymentMode}
                            options={ForceUpdateData}
                            handleChange={(value) => handlePaymentModeChange(value)}
                            label=""
                            width={{ xs: "54%", sm: "45%", md: "55%", lg: "40%" }}
                            multiple={false}
                          />
                        ) : (
                          <>
                            <TextField
                              type={setting.value2 ? "text" : "number"}
                              value={setting.value || setting.value2 || ""}
                              onChange={(e) => handleValueChange(index, e.target.value)}
                              size="small"
                              variant="outlined"
                              sx={{
                                width: setting.unit ? 100 : "100%",
                                "& .MuiInputBase-input": {
                                  textAlign: setting.unit !== "" ? "center" : "start",
                                  fontSize: "14px",
                                  fontWeight: 600,
                                },
                              }}
                              inputProps={
                                setting?.unit
                                  ? {
                                      style: {
                                        textAlign: "center",
                                      },
                                    }
                                  : undefined
                              }
                            />
                            {setting.unit && (
                              <Box
                                sx={{
                                  fontSize: "14px",
                                  color: "#7B809A",
                                  fontWeight: 600,
                                  minWidth: "60px",
                                }}
                              >
                                {setting.unit}
                              </Box>
                            )}
                          </>
                        )}
                      </Box>
                    </TableCell>

                    <TableCell align="left" sx={{ pl: 3 }}>
                      <MDSwitch
                        checked={setting.is_active === 1}
                        onChange={() => handleToggle(index)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>

          <Box mt={4} textAlign="center">
            <SubmitButton btnText="Update" onClick={handleSubmit} type="submit" />
          </Box>
        </Box>
      </TableContainer>
    </DashboardLayout>
  );
};

export default Settings;
